/**
 * O nível do medidor: quanto de um limite já foi usado, e o que dizer sobre isso.
 *
 * Separado do componente para o teste não precisar de tela.
 *
 *   ok      até 90%: só a barra, em roxo suave.
 *   alto    a partir de 90%: a porcentagem ao lado do texto. É a hora de contratar mais.
 *   cheio   no limite ou acima dele: "no limite". A barra para no fim.
 *
 * A porcentagem é arredondada para BAIXO: 99,9% arredondado para cima diria
 * "100%" num medidor que ainda não está cheio.
 */

export type NivelDoMedidor = 'ok' | 'alto' | 'cheio';

/** A partir de que fração do limite o medidor avisa. */
export const LIMIAR_DO_AVISO = 0.9;

export function nivelDoMedidor(
  usado: number,
  total: number,
): { nivel: NivelDoMedidor; fracao: number; marca: string | null } {
  if (total <= 0) return { nivel: 'ok', fracao: 0, marca: null };
  const proporcao = Math.max(usado, 0) / total;
  if (proporcao >= 1) return { nivel: 'cheio', fracao: 1, marca: 'no limite' };
  if (proporcao >= LIMIAR_DO_AVISO) {
    // O 1e-9 tira o ruído do ponto flutuante: 0,93 × 100 dá 93,00000000000001.
    return { nivel: 'alto', fracao: proporcao, marca: `${Math.floor(proporcao * 100 + 1e-9)}%` };
  }
  return { nivel: 'ok', fracao: proporcao, marca: null };
}
